var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGrowthPlanV2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 71,
    height: 70,
    viewBox: "0 0 71 70",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.0139465,
    width: 70,
    height: 70,
    rx: 12,
    fill: "#FEEFD1"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M47.5114 28.75V31.875C47.5114 36.3624 43.8738 40 39.3864 40H36.2614V46.25H33.7614V37.5L33.7851 36.2509C34.1038 32.0552 37.6092 28.75 41.8864 28.75H47.5114ZM27.5115 23.75C31.3769 23.75 34.6569 26.2565 35.8149 29.7328C33.9411 31.3265 32.7034 33.6429 32.5319 36.2505L31.2615 36.25C26.429 36.25 22.5115 32.3325 22.5115 27.5V23.75H27.5115Z",
    fill: "#F9AD19"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGrowthPlanV2);
export default __webpack_public_path__ + "static/media/growth_plan_v2.325dd680aa0616e207845ee6ccc5402a.svg";
export { ForwardRef as ReactComponent };